import "./Task.css";
import { useState, MentorList, Header, SideNav, Info, Select, ExpandMore, TechActionType, useReducer, useEffect, decryptData, useNavigate, axios, handleApiError, SuccessfullVector, CustomModal } from "../AdminImport";
import TechDropdown from "../Task/AssignTask/TechDropdown";

const customStyles = {
  container: (provided, state) => ({
    ...provided,
    fontSize: "1rem",
    fontWeight: "400",
    marginBottom: "0.7rem",
  }),

  menu: (provided) => ({
    ...provided,
    display: "block",
    width: "100%",
    fontSize: "1rem",
    fontWeight: "400",
    lineHeight: "1.5",
    color: "var(--bs-body-color)",
    transition: "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
    zIndex: 30,
  }),
  menuList: (provided) => ({
    ...provided,
    overflowY: "scroll",
    maxHeight: "12rem",
    zIndex: "99",
    "::-webkit-scrollbar": {
      width: "0.5rem",
    },
    "::-webkit-scrollbar-thumb": {
      backgroundColor: "#d9d9d9",
      border: "1px solid rgba(255, 255, 255, 0.1475)",
      borderRadius: "0.875rem",
    },
    "::-webkit-scrollbar-thumb:hover": {
      backgroundColor: "#bfbfbf",
    },
  }),

  valueContainer: (provided, state) => ({
    ...provided,
    maxHeight: "2rem",
    overflow: "auto",
    marginleft: "1rem",
  }),

  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? "lightGrey" : "white",
    color: state.isSelected ? "black" : "black",
  }),

  placeholder: (provided) => ({
    ...provided,
    display: "block",
    width: "100%",
    fontSize: "1rem",
    fontWeight: "400",
    lineHeight: "1.5",
    color: "grey",
    transition: "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
  }),
};

const reducer = (state, action) => {
  switch (action.type) {
    case TechActionType.SET_TECH_VALUE:
      return { ...state, techValue: action.payload };
    case TechActionType.SET_TECH_ID:
      return { ...state, selectedTechIds: action.payload };
    case TechActionType.SET_TECH_NAME:
      return { ...state, selectedTechNames: action.payload };
    default:
      return state;
  }
};

const initialState = {
  selectedTechIds: [],
  selectedTechNames: [],
  techValue: "",
};

const Task = (props) => {
  const { userList } = props;
  const [state, dispatch] = useReducer(reducer, initialState);
  const [mentor, setMentor] = useState({
    technologyNames: [],
    isLoginAllowed: false,
    permissions: [],
    userList: userList,
    userId: null,
    userName: null,
    techDropdown: false,
  });
  const [mentorData, setMentorData] = useState({
    mentor: [],
    userList: [],
    expandMenotr: 0,
    isLoading: true,
  });
  const [modalData, setModalData] = useState({
    modalShow: false,
    isModalOpen: false,
    modalType: "",
    modalTitle: "",
    modalMessage: "",
    icon: null,
  });
  const [editMentor, setEditMentor] = useState({
    editModal: false,
    selectedMentor: [],
  });
  const [editSelectedMentor, setEditSelectedMentor] = useState({
    id: editMentor.selectedMentor[0]?.id || null,
    mentorName: `${editMentor.selectedMentor[0]?.firstName || ""} ${editMentor.selectedMentor[0]?.lastName || ""}`,
    email: editMentor.selectedMentor[0]?.email || "",
    designationName: editMentor.selectedMentor[0]?.designation || "",
    designationId: editMentor.selectedMentor[0]?.designationId || "",
    technologyNames: editMentor.selectedMentor[0]?.skills || [],
    permissions: editMentor.selectedMentor[0]?.userPermission !== "Inactive" ? editMentor.selectedMentor[0]?.userPermission : "",
    isMentorActive: editMentor.selectedMentor[0]?.userPermission == null || editMentor.selectedMentor[0]?.userPermission === "" ? false : true,
    techDropdown: false,
  });

  const navigate = useNavigate();
  const handleUserChange = (e) => {
    setMentor({
      ...mentor,
      userId: e.value,
      userName: e.label,
    });
  };

  const fetchUserList = async () => {
    let parsedObject;
    const data = localStorage.getItem("userData");
    data ? (parsedObject = decryptData(data, process.env.REACT_APP_USER_KEY)) : navigate("/error/statusCode=400");
    const url = `${process.env.REACT_APP_API_URL_DOTNET}/User/getAll`;
    const headers = {
      Authorization: `Bearer ${parsedObject["token"]}`,
    };
    try {
      const response = await axios.get(url, { headers });
      if (response.status == 200) {
        const modifiedUsers = response.data.result.map((user) => ({
          id: user.id,
          name: `${user?.firstName || ""} ${user?.lastName || ""}`,
          designation: user?.designation,
          roleName: user.roleName,
        }));
        const sortedUsers = modifiedUsers.sort((a, b) => {
          const nameA = a.name.toUpperCase();
          const nameB = b.name.toUpperCase();
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0; // names are equal
        });
        const userList = sortedUsers
          .filter((list) => list.designation !== "SDE" && list.designation !== "Intern" && list.roleName.toLowerCase() !== "admin" && list.roleName.toLowerCase() !== "mentor")
          .map((list) => {
            if (list.designation != "SDE" && list.designation != "Intern") return { label: list.name, value: list.id };
          });
        setMentorData((prevState) => ({
          ...prevState,
          userList: userList,
        }));
      } else {
        throw new Error(`Unexpected response status: ${response.status}`);
      }
    } catch (error) {
      const statusCode = error.response ? error.response : null;
      handleApiError(statusCode, navigate);
    }
  };

  const fetchMentorList = async () => {
    let parsedObject;
    const data = localStorage.getItem("userData");
    data ? (parsedObject = decryptData(data, process.env.REACT_APP_USER_KEY)) : navigate("/error/statusCode=400");

    const url = `${process.env.REACT_APP_API_URL_DOTNET}/Dashboard/mentorDetails`;
    const headers = {
      Authorization: `Bearer ${parsedObject["token"]}`,
    };

    try {
      const response = await axios.get(url, { headers });
      if (response.status === 200) {
        const sortedUsers = response.data.result.sort((a, b) => {
          const nameA = a.firstName.toUpperCase();
          const nameB = b.firstName.toUpperCase();
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0;
        });
        setMentorData((prevState) => ({
          ...prevState,
          mentor: sortedUsers,
          isLoading: false,
        }));
      } else {
        throw new Error(`Unexpected response status: ${response.status}`);
      }
    } catch (error) {
      const statusCode = error.response ? error.response : null;
      handleApiError(statusCode, navigate);
    }
  };

  const handleTechChange = (techData) => {
    dispatch({ type: TechActionType.SET_TECH_NAME, payload: techData });
  };

  const handleTechIdChange = (techIdData) => {
    dispatch({ type: TechActionType.SET_TECH_ID, payload: techIdData });
  };

  const handleClickClear = () => {
    setModalData((prevState) => ({
      ...prevState,
      modalShow: false,
      isModalOpen: false,
    }));
  
    if (editMentor.editModal) {
      setEditMentor({
        editModal: false,
        selectedMentor: [],
      });
  
      setEditSelectedMentor({
        id: null,
        mentorName: "",
        email: "",
        designationName: "",
        designationId: "",
        technologyNames: [],
        permissions: "",
        isMentorActive: false,
        techDropdown: false,
      });
  
    } else {
      setMentor((prevState) => ({
        ...prevState,
        technologyNames: [],
        userId: null,
        isLoginAllowed: false,
        permissions: [],
      }));
    }
  
    dispatch({ type: TechActionType.SET_TECH_ID, payload: [] });
    dispatch({ type: TechActionType.SET_TECH_NAME, payload: [] });
    dispatch({ type: TechActionType.SET_TECH_VALUE, payload: "" });
  
    const checkboxes = document.querySelectorAll(".tech-checkbox");
    checkboxes.forEach((checkbox) => {
      checkbox.checked = false;
    });
  };

  // const handleClickClear = () => {
  //   setModalData((prevState) => ({
  //     ...prevState,
  //     modalShow: false,
  //   }));
  //   setMentor((prevState) => ({
  //     ...prevState,
  //     technologyNames: [],
  //     userId: null,
  //     isLoginAllowed: false,
  //     permissions: [],
  //   }));
  //   dispatch({ type: TechActionType.SET_TECH_ID, payload: [] });
  //   dispatch({ type: TechActionType.SET_TECH_NAME, payload: [] });
  //   dispatch({ type: TechActionType.SET_TECH_VALUE, payload: "" });
  //   const checkboxes = document.querySelectorAll(".tech-checkbox");
  //   checkboxes.forEach((checkbox) => {
  //     checkbox.checked = false;
  //   });
  // };

  // const handlePermissionSave = (e) => {
  //   const { name } = e.target;
  //   switch (name) {
  //     case "IsLoginAllowed":
  //       setMentor((prevState) => {
  //         const newIsLoginAllowed = !prevState.isLoginAllowed;
  //         const allPermissions = "Session,Project,Review,Know Your Mentor";
  //         return {
  //           ...prevState,
  //           isLoginAllowed: newIsLoginAllowed,
  //           permissions: newIsLoginAllowed ? allPermissions : "",
  //         };
  //       });
  //       break;
  //   }
  // };

  const handleFormSubmit = async () => {
    let parsedObject;
    const data = localStorage.getItem("userData");
    data ? (parsedObject = decryptData(data, process.env.REACT_APP_USER_KEY)) : navigate("/error/statusCode=400");
    const url = `${process.env.REACT_APP_API_URL_DOTNET}/User/UpdateUserRole`;
    const body = {
      id: mentor.userId,
      skillsId: state.selectedTechIds,
      isLoginAllowed: mentor.isLoginAllowed,
      userPermission: mentor.permissions.length == 0 ? "" : mentor.permissions,
    };
    const headers = {
      Authorization: `Bearer ${parsedObject["token"]} `,
    };

    const response = await axios.post(url, body, { headers });
    if (response.status == 200) {
      await fetchMentorList();
      await fetchUserList();
      handleClickClear();
      setModalData((prevState) => ({
        ...prevState,
        isModalOpen: true,
        modalType: "success",
        modalTitle: "Grader Role Assigned Successfully",
        modalMessage: "",
        icon: <SuccessfullVector />
      }));
    } else {
      alert(response.data.result.message);
    }
  };

  const handleSave = async () => {
    let parsedObject;
    const data = localStorage.getItem("userData");
    data ? (parsedObject = decryptData(data, process.env.REACT_APP_USER_KEY)) : navigate("/error/statusCode=400");

    const url = `${process.env.REACT_APP_API_URL_DOTNET}/User/UpdateUserRole`;
    const body = {
      id: editSelectedMentor.id,
      skillsId: state.selectedTechIds,
      isLoginAllowed: editSelectedMentor.isMentorActive,
      userPermission:
        editMentor.selectedMentor[0]?.userPermission !== "Inactive"
          ? editSelectedMentor.permissions.trim()
          : editSelectedMentor.permissions.substring(0, editSelectedMentor.permissions.lastIndexOf(",")),
    };
    const headers = {
      Authorization: `Bearer ${parsedObject["token"]} `,
    };
    const response = await axios.post(url, body, { headers });
    if (response.status == 200) {
      fetchMentorList();
      fetchUserList();
      handleClickClear();
      setModalData((prevState) => ({
        ...prevState,
        isModalOpen: true,
        modalType: "success",
        modalTitle: "Grader Role Updated Successfully",
        modalMessage: "",
        icon: <SuccessfullVector />
      }));    
    } else {
      alert(response.data.result.message);
    }
  };

  useEffect(() => {
    const isTechEmpty = Object.keys(state.selectedTechNames).length !== 0;
    if (isTechEmpty) {
      const techValueString = Object.values(state.selectedTechNames).join(", ");
      dispatch({ type: TechActionType.SET_TECH_VALUE, payload: techValueString });
    } else {
      dispatch({ type: TechActionType.SET_TECH_VALUE, payload: "" });
    }
  }, [state.selectedTechNames, state.selectedTechIds, state.closeModal]);
  

  // useEffect(() => {
  //   const isTechEmpty = Object.keys(state.selectedTechNames).length !== 0;
  //   if (isTechEmpty) {
  //     const techValueString = Object.values(state.selectedTechNames).join(", ");
  //     dispatch({ type: TechActionType.SET_TECH_VALUE, payload: techValueString });
  //   }
  // }, [state.selectedTechNames, state.selectedTechIds, state.closeModal]);

  useEffect(() => {
    fetchUserList();
  }, []);

  return (
    <>
      <div style={{ marginBottom: "5rem" }}>
        <Header />
        <SideNav />
      </div>

      <div className="container">
      <h3 className="milestone-header">Manage Grader</h3>
      <div className="alert alert-info mb-0 box-for-alert-message mt-2" role="alert">
        <div className="d-flex justify-content-center align-items-center">
          <Info />
        </div>
        <div className="text-for-alert">
          <p className="m-0 mx-2">Grader role if assigned to user from this page, will apply to the assigned users through out the entire system, including dashboard and courses.</p>
        </div>
      </div>
        <div className="container-fluid ">
          <div className="row mt-4 gap-3">
            {/* <div className=" col-md-7 p-0" style={{ marginLeft: "56px" }}>
              <AssignTask selectedBatches={selectedBatches} />
            </div> */}
            <div className=" col-md-6 p-0 ">
              <MentorList
                editMentor={editMentor}
                setEditMentor={setEditMentor}
                editSelectedMentor={editSelectedMentor}
                setEditSelectedMentor={setEditSelectedMentor}
                mentorData={mentorData}
                setMentorData={setMentorData}
                fetchMentorList={fetchMentorList}
                fetchUserList={fetchUserList}
              />
            </div>
            <div className="col-md-5 p-0">
              <div className="align-items-center">
                <div className="mentor-list-container">
                  {editMentor.editModal && editMentor.selectedMentor.length > 0 ? <p>Edit Grader</p> : <p>Assign Grader</p>}                  
                </div>
                <div className="card p-3 assign-grader-card" style={{ boxShadow: "0 4px 20px rgba(40, 52, 73, 0.15)" }}>
                  <form>
                    <div style={{padding: "0.375rem"}}>
                      Select User <span style={{ color: "red" }}>*</span>
                    </div>
                    <Select
                      styles={customStyles}
                      className="basic-single"
                      classNamePrefix="select"
                      options={mentorData.userList}
                      placeholder="Select User To Assign Role"
                      onChange={handleUserChange}
                      isDisabled={editMentor.editModal && editMentor.selectedMentor.length > 0}
                      value={
                        editMentor.editModal && editMentor.selectedMentor.length > 0
                          ? {
                              label: `${editSelectedMentor.mentorName}`,
                              value: editMentor.selectedMentor[0].id,
                            }
                          : mentor.userId != null && {
                              label: mentor.userName,
                              value: mentor.userId,
                            }
                      }
                      // value={
                      //   mentor.userId != null && {
                      //     label: mentor.userName,
                      //     value: mentor.userId,
                      //   }
                      // }
                    />
                    <div className="mb-3">
                      <label htmlFor="skills" className="col-form-label d-flex">
                        Technology Tags <span style={{ color: "red" }}>*</span>
                      </label>

                      <div className="container border p-0" style={{ borderRadius: "0.375rem" }}>
                        <div
                          className="input-with-button-grader"
                          onClick={() => {
                            setMentor((prevState) => ({
                              ...prevState,
                              techDropdown: !prevState.techDropdown,
                            }));
                          }}
                        >
                          <input
                            style={{ width: "calc(100% - 2rem)" }}
                            type="text"
                            className="custom-input"
                            placeholder="Select Technology"
                            value={state.techValue ? state.techValue : ""}
                          />
                          <div
                            className="modal-abs"
                            style={{
                              position: "absolute",
                              left: "0",
                              right: "0",
                              top: "0",
                              bottom: "0",
                            }}
                          ></div>
                          <ExpandMore className="ms-2 grader-expand-icon-color"/>
                        </div>
                        <div>
                          <ul style={{ display: mentor.techDropdown ? "" : "none", width: "calc(100% - 2rem)"}} className="ul-styling">
                            <TechDropdown
                              dispatch={dispatch}
                              techDataComingChild={handleTechChange}
                              selectedTechIdsfromChild={handleTechIdChange}
                              selectedTechIds={state.selectedTechIds}
                              technologyNames={state.selectedTechNames}
                              selectedTech={editMentor.selectedMentor[0]?.skills}
                            />
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginTop: "1.5rem"
                      }}
                    >
                      {(editMentor.editModal && editMentor.selectedMentor.length > 0 && editSelectedMentor.isMentorActive) || mentor.isLoginAllowed ? <h5 className="m-0 modalheading-text" style={{ fontSize: "14px" }}>
                        Deactivate Grader
                      </h5> : <h5 className="m-0 modalheading-text" style={{ fontSize: "14px" }}>
                        Activate Grader
                      </h5>}
                      <div className="form-check form-switch">
                        <input
                          className="form-check-input ms-2"
                          type="checkbox"
                          id="toggleButton"
                          name="IsLoginAllowed"
                          checked={editMentor.editModal && editMentor.selectedMentor.length > 0 ? editSelectedMentor.isMentorActive : mentor.isLoginAllowed}
                          value={editMentor.editModal && editMentor.selectedMentor.length > 0 ? editSelectedMentor.isMentorActive : mentor.isLoginAllowed}
                          onChange={(e) => {
                            const isChecked = e.target.checked;

                            if (editMentor.editModal && editMentor.selectedMentor.length > 0) {
                              setEditSelectedMentor((prev) => ({
                                ...prev,
                                isMentorActive: isChecked,
                                permissions: "Session,Project,Review,Know Your Mentor",
                              }));
                            } else {
                              setMentor((prev) => ({
                                ...prev,
                                isLoginAllowed: isChecked,
                                permissions: "Session,Project,Review,Know Your Mentor",
                              }));
                            }
                          }}
                        />
                      </div>
                    </div>
                    <div>
                    {editMentor.editModal && editMentor.selectedMentor.length > 0 && <p className="task-error-msg">Deactivating grader will remove the grader from graders list</p>}
                    </div>
                  </form>
                  <div className="d-flex justify-content-between assign-grader-action-buttons">
                    <button type="button" className="btn cancel-button fw-bold me-2" onClick={handleClickClear}>
                      <span className="cancel-text">Cancel</span>
                    </button>

                    <button
                      type="button"
                      className="btn btn-primary mentor-save-button fw-bold"
                      onClick={editMentor.editModal ? handleSave : handleFormSubmit}
                      disabled={
                        (editMentor.editModal
                          ? editSelectedMentor.id === null || state.selectedTechIds.length === 0
                          : mentor?.userId === null || state.selectedTechIds.length === 0 || !mentor.isLoginAllowed)
                      }                      
                    >
                      <span className="save-text">{editMentor.editModal ? "Save" : "Add"}</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {modalData.isModalOpen && (
        <CustomModal
          modalProps={{
            icon: modalData.icon,
            show: modalData.isModalOpen,
            type: modalData.modalType,
            title: modalData.modalTitle,
            message: modalData.modalMessage,
            onCancel: handleClickClear,
          }}
        />
      )}
    </>
  );
};

export default Task;
